<template>
  <account-verify platform="portal"/>
</template>

<script>
import AccountVerify from '../../components/assemble-account/AccountVerify.vue';

export default {
  name: 'Verify',
  components: {
    'account-verify': AccountVerify
  }
};
</script>

<style scoped lang="scss">
</style>
